export default __webpack_public_path__ + "static/media/bell.cad13693.svg";